import React from "react";

const SEMGReports = () => {
    return (
        <div>
            <h1>SEMGReports</h1>
        </div>
    );
}

export default SEMGReports;